import { ORIGINAL_UI_MANIFEST } from "../data/generated/original-ui-manifest";

export const ORIGINAL_UI_RUNTIME_CONSUMPTION = {
  manifest: "docs/original-ui-manifest.json",
  generatedManifestModule: "web/src/data/generated/original-ui-manifest.ts",
  consumesDecodedUi: true,
  sourceBackedStatus: ORIGINAL_UI_MANIFEST.status,
  sourceBackedCriteria: {
    statusPanelDrawRulesDecoded: ORIGINAL_UI_MANIFEST.criteria.statusPanelDrawRulesDecoded,
    messagePrintLayoutDecoded: ORIGINAL_UI_MANIFEST.criteria.messagePrintLayoutDecoded,
    messageQueuePrimitivesDecoded: ORIGINAL_UI_MANIFEST.criteria.messageQueuePrimitivesDecoded,
    menuVisibilityRulesDecoded: ORIGINAL_UI_MANIFEST.criteria.menuVisibilityRulesDecoded,
    seeWindowRulesDecoded: ORIGINAL_UI_MANIFEST.criteria.seeWindowRulesDecoded,
    messageCommandEffectsManifestSatisfied: ORIGINAL_UI_MANIFEST.criteria.messageFlowScopedToMessageEffectsManifest,
    frmFullDecodeNotRequiredForUiGate: ORIGINAL_UI_MANIFEST.criteria.frmFullDecodeNotRequiredForUiGate
  }
} as const;

export function originalUiRuntimeConsumesDecodedUi(): boolean {
  return ORIGINAL_UI_RUNTIME_CONSUMPTION.consumesDecodedUi;
}

export function originalStatusPanelActorName(actor: { name: string }): string {
  return actor.name.slice(0, 8);
}

export const ORIGINAL_MESSAGE_PRINT_LAYOUT = {
  x: 8,
  y: 314,
  lineHeight: 22,
  maxLines: 3,
  scrollCopy: { x: 8, y: 313, width: 496, height: 44, sourceY: 335 },
  clearBottom: { x: 8, y: 357, width: 496, height: 22 }
} as const;

export function originalMessageTextLines(text: string): string[] {
  return [text];
}

export function originalMessagePrintLines(currentLines: readonly string[], text: string): string[] {
  const next = [...currentLines].slice(-ORIGINAL_MESSAGE_PRINT_LAYOUT.maxLines);
  for (const line of originalMessageTextLines(text)) {
    if (next.length > ORIGINAL_MESSAGE_PRINT_LAYOUT.maxLines - 1) next.shift();
    next.push(line);
  }
  return next;
}
